import type { Upload } from "@campaign-media/shared";

interface ClientConfig { supabaseUrl: string; supabaseAnon: string; storageBucket: string; }

export class PhotoClient {
  constructor(private cfg: ClientConfig) {}

  async fetchPage(campaignId: string, page: number, pageSize = 24): Promise<Upload[]> {
    const from = page * pageSize;
    const to = from + pageSize - 1;
    const url = `${this.cfg.supabaseUrl}/rest/v1/uploads?campaign_id=eq.${campaignId}&status=eq.approved&order=submitted_at.desc`;
    const res = await fetch(url, {
      headers: {
        apikey: this.cfg.supabaseAnon,
        Authorization: `Bearer ${this.cfg.supabaseAnon}`,
        Range: `${from}-${to}`,
        Prefer: "count=exact",
      },
    });
    if (!res.ok) throw new Error(`fetch failed ${res.status}`);
    return await res.json();
  }

  async fetchActiveCampaignId(): Promise<string | null> {
    const url = `${this.cfg.supabaseUrl}/rest/v1/campaigns?is_active=eq.true&select=id`;
    const res = await fetch(url, {
      headers: { apikey: this.cfg.supabaseAnon, Authorization: `Bearer ${this.cfg.supabaseAnon}` },
    });
    if (!res.ok) return null;
    const rows = await res.json();
    return rows[0]?.id ?? null;
  }

  // Photos live in Firebase Storage. Approved/* objects are public-read per storage.rules.
  // The Firebase Storage public download URL pattern is /v0/b/<bucket>/o/<encoded-path>?alt=media.
  publicUrl(path: string): string {
    return `https://firebasestorage.googleapis.com/v0/b/${this.cfg.storageBucket}/o/${encodeURIComponent(path)}?alt=media`;
  }
}
